import { render, staticRenderFns } from "./TreeH.vue?vue&type=template&id=20070734&scoped=true&"
import script from "./TreeH.vue?vue&type=script&lang=js&"
export * from "./TreeH.vue?vue&type=script&lang=js&"
import style0 from "./TreeH.vue?vue&type=style&index=0&id=20070734&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20070734",
  null
  
)

export default component.exports